/* eslint-disable camelcase */
import ES6Promise from 'es6-promise';
import axios from 'axios';

ES6Promise.polyfill();

class LocationApiService {
  static getLocationsMarkers(areaId, kind) {
    if (!window.location.origin) {
      // eslint-disable-next-line max-len
      window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    }

    return axios.get(`${window.location.origin}/api/frontend/locations/map_markers?`, { params: { area_ids: areaId, kind } })
      .then(response => response.data);
  }

  static getLocationsList(areaId, page, kind) {
    if (!window.location.origin) {
      // eslint-disable-next-line max-len
      window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
    }

    return axios.get(`${window.location.origin}/api/frontend/locations/list?`, { params: { area_ids: areaId, page, kind } })
      .then(response => response.data);
  }

  static postFormOrder(data) {
    const bodyFormData = LocationApiService.orderFormData(data);

    return axios.post(`${window.location.origin}/api/frontend/orders`, bodyFormData)
      .then(response => response.data)
      .catch((error) => {
        console.log(error);
      });
  }

  static postFormUncompletedOrder(data) {
    const bodyFormData = LocationApiService.orderFormData(data);

    return axios.post(`${window.location.origin}/api/frontend/orders/create_uncompleted`, bodyFormData)
      .catch((error) => {
        console.log(error);
      });
  }

  static finishUncompletedOrder(data) {
    const bodyFormData = LocationApiService.orderFormData(data);

    return axios.post(`${window.location.origin}/api/frontend/orders/finish_uncompleted`, bodyFormData)
      .then(response => response.data)
      .catch((error) => {
        console.log(error);
      });
  }

  static deleteUncompletedOrder(data) {
    const params = { authenticity_token: data.authenticity_token, email: data.email };

    return axios.delete(`${window.location.origin}/api/frontend/orders/destroy_uncompleted`, { data: params })
      .then(response => response.data)
      .catch((error) => {
        console.log(error);
      });
  }

  static orderFormData(data) {
    const bodyFormData = new FormData();

    bodyFormData.append('authenticity_token', data.authenticity_token);
    bodyFormData.append('email', data.email);
    bodyFormData.append('firm', data.firm);
    bodyFormData.append('name', data.name);
    bodyFormData.append('phone', data.phone);
    bodyFormData.append('comments', data.comments);

    data.location_ids.map(elem => bodyFormData.append('location_ids[]', elem));

    return bodyFormData;
  }

  static virtualTourForm(data, url, token) {
    const info_request = {
      client_email: data.email,
      client_company: data.company,
      client_name: data.name,
      client_phone: data.phone,
      area: data.area,
    };

    return axios.post(`${window.location.origin}${url}`, {authenticity_token: token, info_request})
      .then(response => response)
      .catch((error) => {
        console.log(error);
      });

  }

  static signUpForm(data, url, token) {
    const provider_request = {
      name: data.name,
      company: data.company,
      email: data.email,
      phone: data.phone,
      zipcode: data.zipcode,
      address: data.address,
    };

    return axios.post(`${window.location.origin}${url}`, {authenticity_token: token, provider_request})
      .then(response => response)
      .catch((error) => {
        console.log(error);
      });

  }

  static quickSearchForm(data, url, token) {

    const quick_request = {
      name: data.name,
      company: data.company,
      email: data.email,
      phone: data.phone,
      search: data.search,
      comment: data.comment,
    };

    return axios.post(`${window.location.origin}${url}`, {authenticity_token: token, quick_request})
      .then(response => response)
      .catch((error) => {
        console.log(error);
      });

  }
}

export default LocationApiService;
